import React from 'react';
import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
const styles = require('./ValuePropsList.module.css');

export function ValuePropsList({ children, className }) {
  return <ul className={classNames(styles.valuePropsList, className)}>{children}</ul>;
}

export function ValuePropIcon({ icon, size, className }) {
  return (
    <div
      className={classNames(
        styles.valuePropItemCheckmark,
        styles[`valuePropItemCheckmark${capitalize(size)}`],
        className
      )}
    >
      <img src={icon} aria-hidden="true" alt="checkmark" />
    </div>
  );
}

const valuePropItemAlignMapping = {
  center: styles.center,
  'flex-start': styles.flexStart,
};
const DEFAULT_VALUE_PROP_ITEM_ALIGNMENT = valuePropItemAlignMapping.center;

export function ValuePropItem({
  children,
  icon,
  className,
  alignItems = 'center',
  iconSize = 'small',
}) {
  const valuePropAlignmentClass =
    valuePropItemAlignMapping[alignItems] || DEFAULT_VALUE_PROP_ITEM_ALIGNMENT;

  return (
    <li className={classNames(styles.valuePropItem, valuePropAlignmentClass, className)}>
      {icon && <ValuePropIcon icon={icon} size={iconSize} />}
      <div className={styles.valuePropItemText}>{children}</div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/components/elements/ValuePropsList/index.js